/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
// ==========Simple Collapsible=========

{

  const mobileToolbarBtn = document.querySelectorAll('.mobile-toolbar__item--sort');

  const mobileNavLink = document.querySelectorAll('.mobile-nav__link');

  const toggleButtons = document.querySelectorAll('.collapsible-toggle');

  const filterApply = document.querySelectorAll('.filter-apply-item.apply');

  function toggleCollapsible(event) {
    event.stopPropagation();
    toggleButtons.forEach((button) => {
      if (button !== this) {
        let defaultOpen = button.classList.contains("default-open");
        if (!defaultOpen) {
          button.setAttribute('aria-expanded', false);
        }

      }
    });
    // ==========Menu Collapsible=========

    mobileNavLink.forEach((button) => {
      if (button !== this) {
        // button.classList.remove("cus-active");
        defaultOpen = button.classList.contains("default-open");
        if (!defaultOpen) {
          button.setAttribute('aria-expanded', false);
        }
      }
    });
  }
  // ==========On Save Collapsible=========

  function saveToggleCollapsible() {
    let parent = this.parentNode;
    let collapsible = parent.parentNode;
    let toggleButton = collapsible.previousElementSibling;
    let isExpanded = toggleButton.getAttribute("aria-expanded");
    if (isExpanded) {
      toggleButton.setAttribute('aria-expanded', false);
    }
    let toggleFilterBtn = document.querySelectorAll('.mobile-toolbar__item--filters');

    toggleFilterBtn.forEach((button) => {
      button.setAttribute('aria-expanded', false);
    });
  }
  function sortByToggle() {
    console.log("sort-clicked");
    let mobileToolbarFilterBtn = this.previousElementSibling;
    console.log(mobileToolbarFilterBtn);

    let isExpanded = mobileToolbarFilterBtn.getAttribute("aria-expanded");
    console.log(isExpanded);

    if (isExpanded) {
      mobileToolbarFilterBtn.setAttribute('aria-expanded', true);
    }
    let toggleSortBy = document.querySelectorAll('.collapsible-toggle.sortby');

    toggleSortBy.forEach((button) => {
      button.setAttribute('aria-expanded', true);
    });
  }
  mobileToolbarBtn.forEach((button) => {
    button.addEventListener('click', sortByToggle);
  });

  filterApply.forEach((button) => {
    button.addEventListener('click', saveToggleCollapsible);
  });

  // mobileNavLink.forEach((button) => {
  //   button.addEventListener('click', toggleCollapsible);
  // });

  // toggleButtons.forEach((button) => {
  //   button.addEventListener('click', toggleCollapsible);
  // });
}
// ==========Mutation Observer Collapsible=========
// Don't add event listners to outside target observer
{
  let targetElement = document.getElementById("facet-filters");
  if (targetElement) {
    window.addEventListener('DOMContentLoaded', (event) => {
      console.log('DOM fully loaded and parsed');

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              const toggleButtons = document.querySelectorAll('body .collapsible-toggle');
              const filterApply = document.querySelectorAll('.filter-apply-item.apply');

              function toggleCollapsible(event) {
                event.stopPropagation();
                toggleButtons.forEach((button) => {
                  if (button !== this) {
                    let defaultOpen = button.classList.contains("default-open");
                    if (!defaultOpen) {
                      button.setAttribute('aria-expanded', false);
                    }
                  }
                });
              }
              // ==========On Save Collapsible=========

              function saveToggleCollapsible() {
                let parent = this.parentNode;
                let collapsible = parent.parentNode;
                let toggleButton = collapsible.previousElementSibling;
                let isExpanded = toggleButton.getAttribute("aria-expanded");
                if (isExpanded) {
                  toggleButton.setAttribute('aria-expanded', false);
                }
                let toggleFilterBtn = document.querySelectorAll('.mobile-toolbar__item--filters');

                toggleFilterBtn.forEach((button) => {
                  button.setAttribute('aria-expanded', false);
                });
              }

              filterApply.forEach((button) => {
                button.addEventListener('click', saveToggleCollapsible);
              });

              toggleButtons.forEach((button) => {
                button.addEventListener('click', toggleCollapsible);
              });
            });
          }
        });
      });

      observer.observe(targetElement, { childList: true, subtree: true });
    });

  }
}


jQuery(function () {
  $('.product-text-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1
  });
  $('.product-recomandations-slider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.product__media-item[data-media-type="image"]').click(function () {
    $('.product__media-item + .product__zoom-button').attr('aria-expanded', 'true');
  });

});



// Open the default tab on page load
let yes = document.getElementById('yes');
if (yes) {
  yes.style.display = "block";
}

// Function to switch tabs
function openTab(evt, tabName) {
  // Declare variables
  var i, tabcontent, tablinks;

  // Hide all tab content
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    tabcontent[i].classList.remove("active");
  }

  // Remove the active class from all tab links
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  document.getElementById(tabName).classList.add("active");
  evt.currentTarget.classList.add("active");
}

/**
 * Fancybox Script Start
 */

const mainProductCarouselDiv = document.querySelectorAll("#mainProductCarousel");

if (window.innerWidth <= 1024) {
  $(mainProductCarouselDiv).on("beforeChange", function (){
    setTimeout(function() {
      var src = $('#mainProductCarousel .slick-slide.slick-active').data('src');
      
      $('.fancybox-btn').data('src',src);
    }, 200);
  });

  $('.fancybox-btn').on("click", function (){
    setTimeout(function() {
      var src = $('.fancybox-btn').data('src');
      
      $('img.fancybox-image').attr('src',src);
    }, 100);
  });
}
$(document).ready(function () {

$('[data-fancybox="gallery"]').fancybox({
  arrows: false,
  keyboard: true,
  toolbar: "auto",
  buttons: [
    //"zoom",
    //"share",
    //"slideShow",
    //"fullScreen",
    //"download",
    //"thumbs",
    "close"
  ],
  wheel: "auto",
  transitionEffect: "fade",
  thumbs: {
    autoStart: true
  }
});
});

if(window.location.href.includes('faq')){
  var click_val = window.location.href.toLowerCase().replace("%20", " ").replace("%20", " ").replace("%20", " ").split('#')[1];
  if($('.tablinks p[data-title="'+click_val+'"]').length > 0){
    $('.tablinks p[data-title="'+click_val+'"]').parent().click();
  }
}


$(document).on("click","#mainProductCarousel .carousel__slide.media-image",function() {
    $('.fancybox-button--thumbs').click();
});



// Free gift counter: refresh on load and when an option is picked from a dropdown. (The old vintage product page
// check that used to run here was removed with the Vintage template.)
$('.combo-box .combo-box__option-item').on('click', function () {
  minusGiftCounterFromCart();
});

minusGiftCounterFromCart();

$('.input.switch input').click(function() {
    var free_product = parseInt($(this).closest('.free_product').attr('variant-id'));
    if ($(this).is(':checked')) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: free_product,
                properties: {
                    'freegift': 'freegift',
                }
            },
            cache: false,
            async: false,
            success: function(data) {
                console.log(data);
            },
            error: function(data) {
                console.log(data);
            }
        });
    } else {
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                id: free_product,
                quantity: 0,
            },
        }).then((data) => {
            document.querySelector("#mini-cart .drawer__content").innerHTML = "";
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
            }));
            $('cart-count').text('0')
        });
    }
});

function removeFreegift() {
    var varint_id = parseInt($('.free_gift_id').attr('varaint-id'));
    if (varint_id != "") {
        $.getJSON('/cart.js', function(cart) {
            if (cart.item_count == 1) {
                $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    dataType: "json",
                    data: {
                        id: varint_id,
                        quantity: 0,
                    },
                }).then((data) => {

                    document.querySelector("#mini-cart .drawer__content").innerHTML = "";
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                    $('cart-count').text('0')

                });
            }
        });
    }
}

function addFreeGift() {
 var free_product = parseInt($('.cart .free_product .input.switch input').closest('.free_product').attr('variant-id'));
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                quantity: 1,
                id: free_product,
                properties: {
                    'freegift': 'freegift',
                }
            },
            cache: false,
            async: false,
            success: function(data) {
              $('.cart .free_product .input.switch input').prop('checked', true);
            }
        });
}

$(document).on('click', 'line-item-quantity', function() {
    var varint_id = parseInt($('.free_gift_id').attr('varaint-id'));
    if (varint_id != "") {
        setTimeout(function() {
            $.getJSON('/cart.js', function(cart) {
                if (cart.item_count == 1) {
                    $.ajax({
                        type: "POST",
                        url: "/cart/change.js",
                        dataType: "json",
                        data: {
                            id: varint_id,
                            quantity: 0,
                        },
                    }).then((data) => {

                        document.querySelector("#mini-cart .drawer__content").innerHTML = "";
                        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true
                        }));
                        $('cart-count').text('0')

                    });
                }else{
                  minusGiftCounterFromCart();
                }
            });
        }, 1000);
    } else {
        console.log(varint_id);
    }
});
function minusGiftCounterFromCart(){
     $.getJSON('/cart.js', function(cart) {
       var varint_id = parseInt($('.free_gift_id').attr('varaint-id'));
        if (varint_id != "") {
            var exist = false;
          cart.items.forEach(function (item) {
              if(parseInt(item.variant_id) == parseInt(varint_id)){
                  exist = true;
                  return;
              }
              
          });
            if(exist == true){
             $('cart-count').text(parseInt(cart.item_count) -1);
                var dwr_text = $('.drawer__title').text();
                $('.drawer__title').text(dwr_text.replace(cart.item_count, parseInt(cart.item_count) -1));
            }
        }
    })
}

$(document).on('click', '.filter-apply-wrap button', function() {
    setTimeout(function() {
        var count = $('.product-facet__aside .drawer__title .bubble-count').text();
        $('.mobile-toolbar__item--filters .mobile-toolbar__item-label .bubble-count').text(count);
    }, 2000);
});
$(document).on('click','[data-action=clear-filters]',function () {
     $('.mobile-toolbar__item--filters .mobile-toolbar__item-label .bubble-count').text(0);
});
$('.cart-sidebar-discount .discount-code-container').click(function() {
    $('.cart-sidebar-discount .cart_disoucnt_content').toggle();
});
// window.addEventListener('click', (event) => {
//     var details = $('.collapsible-toggle[aria-expanded=true]');
//     var finded = false;
//     if (event.target.closest(".product-facet__filter-item") == null) {
//         finded = true;
//     }

//     if (finded == true) {
//         details.next().find('[data-filter-submit]').trigger('click');
//     }
// });
$(document).on('click','facet-filters .drawer__footer .button2',function (params) {
   $('#facet-filters-form [data-filter-submit]').trigger('click');
    $(this).next().trigger('click');
  
})

 $(document).ready(function() {
    $('a.line-item__remove-button').on('click', function(e) {
      e.preventDefault();
      var deleteLink = $(this).attr('href'); 
      $.ajax({
        type: 'GET',
        url: deleteLink,
        dataType: 'json',
        success: function(response) {
        console.log(response);          
        if (response.item_count === 1) {
            let extra_pro = $('.cart-topheader').attr('data-free-product');
            if(extra_pro)
            {
              let freepro = parseInt(extra_pro);
              if(freepro == response.items[0].id)
              {
                $(`[data-free-pro-item="${freepro}"]`).find('a').click();
              }
              else
              {
                  location.reload();
              }
              
            }
           
          } else {
              location.reload();
          }
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log('Error: ' + textStatus);
        }
      });
    });

   
  });

$(document).on('click', '#facet-filters-form input[type="checkbox"]', function() {
    var input_length = $(this).closest('collapsible-content').find('input:checked').length;
    if($('#facet-filters-form input:checked').length>0){
     $('.product-facet .drawer__footer').removeClass('displayNone');
    }else{
     $('.product-facet .drawer__footer').addClass('displayNone');
    }
   
    if (input_length > 0) {
        $(this).closest('.product-facet__filter-item').find('button .pffI_text span').remove("span");
        $(this).closest('.product-facet__filter-item').find('button .pffI_text').append("<span>" + input_length + "</span>");
    } else {
        $(this).closest('.product-facet__filter-item').find('button .pffI_text span').remove("span");
    }
  imageChnage();
});

// $(document).ready(function() {
// if($('.cart .free_product .input.switch input').prop('checked') == false){
//   addFreeGift();
// }
// });
  
// $('.faq .tabs-inner').slick({
//   slidesToShow: 4,
//   infinite: false,
//   slidesToScroll: 4
// });

var sliderfaq = $('.faq .tabs-inner');

sliderfaq.slick({
  slidesToShow: 4,
  infinite: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 1000, 
  responsive: [
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }
  ]
});

  setTimeout(function () {
    sliderfaq.slick('slickPause');
  }, 5000);



$(document).on('click', '.product-meta__help', function() {
  var value = $(this).data('id');
  $(this).parent().find('drawer-content').find('[data-id="'+value+'"]').click()
});


// TRust pilot
$(document).ready(function() {
    setInterval(function() {
        $('#trustpilot-widget-trustbox-0').css('z-index', 'unset');
    }, 100); 

  // free_gift_id 47175569670482 this will remove the free gift if already have in cart when we not providing free removeFreegift
     $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: 47175569670482,
          quantity: 0,
        },
    }).then((data) => {
  
    });
});


// $(document).on('click', '[data-h="mobile-controls-zoom-in"]', function() {
//   debugger
// });

$(document).ready(function() {
  // Function to check if any radio button is checked and remove the 'displayNone' class
  function toggleDrawerFooter() {
    if ($('input[name="sort_by"]:checked').length > 0) {
      countFiltersFromURL();
      $('.drawer__footer').removeClass('displayNone');
    }
  }
  $( ".collection-page" ).on( "change", 'input[name="sort_by"]', function() {
     toggleDrawerFooter();
});

 countFiltersFromURL();

  
  
});


function countFiltersFromURL() {
  const url = window.location.href;
  const urlParams = new URL(url).searchParams;
  let filterCount = 0;
  urlParams.forEach((value, key) => {
    if (value) {
      filterCount += 1;
    }
  });
  document.querySelector('.product-facet__active-count').textContent = filterCount;
}


const handleSwatches = (container) => {
  container.querySelectorAll('.product-item-meta__swatch-list').forEach(swatchList => {
    const swatches = swatchList.querySelectorAll('.color-swatch');
    
    // Skip if already modified
    if (swatchList.querySelector('.more-swatches')) return;

    if (swatches.length > 4) {
      for (let i = 4; i < swatches.length; i++) {
        swatches[i].style.display = 'none';
      }

      const remainingCount = swatches.length - 4;
      const moreSwatches = document.createElement('div');
      moreSwatches.className = 'more-swatches';
      moreSwatches.innerText = `+${remainingCount}`;

      swatchList.appendChild(moreSwatches);
    }
  });
};

// Initial run for already-loaded products
handleSwatches(document);

// Observe the DOM for dynamically added recommended products
const observer = new MutationObserver(mutations => {
  for (let mutation of mutations) {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        handleSwatches(node);
      }
    });
  }
});

observer.observe(document.body, { childList: true, subtree: true });

$('.pdp-featured-collections .product-list__inner').slick({
  slidesToShow: 3.3,
  slidesToScroll: 3,
  dots: false,
  arrows: true,
  prevArrow: '<div class="slick-slider__prev"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"></path></svg></div>',
  nextArrow: '<div class="slick-slider__next"><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"></path></svg></div>',
  infinite: false,
   responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 2,
      }
    }
  ]
});

$(window).on('load', function () {
  if (window.innerWidth <= 1000) {
    const $slider = $('.product__media-wrapper .glide__slides');

    $slider.after('<div class="slick-progress"><div class="slick-progress-bar"></div></div>');

    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      let i = (currentSlide ? currentSlide : 0) + 1;
      let progress = (i / slick.slideCount) * 100;
      $('.slick-progress-bar').css('width', `${progress}%`);
    });

    $slider.on('init', function () {
      setTimeout(() => {
        $slider.slick('setPosition'); // fixes last-slide-jumping bug
      }, 50);
    });

    $slider.slick({
      slidesToShow: 1.09,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false
    });
  }
});


// custom view all drawer starts here

document.addEventListener('DOMContentLoaded', function () {
  const drawerButton = document.getElementById('view-all-popup');

  if (!drawerButton) return;

  drawerButton.addEventListener('click', function (event) {
    event.preventDefault();

    const drawerId = drawerButton.getAttribute('aria-controls');
    const drawer = document.getElementById(drawerId);

    // If drawer not found, exit
    if (!drawer) {
      console.warn('Drawer not found:', drawerId);
      return;
    }

    // Open drawer
    drawer.classList.add('is-open');
    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');

    // Close logic
    const overlay = drawer.querySelector('.drawer__overlay');
    const closeBtn = drawer.querySelector('.drawer__close-button');

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.removeAttribute('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    };

    // Attach close handlers if not already attached
    if (overlay && !overlay.dataset.bound) {
      overlay.addEventListener('click', closeDrawer);
      overlay.dataset.bound = true;
    }

    if (closeBtn && !closeBtn.dataset.bound) {
      closeBtn.addEventListener('click', closeDrawer);
      closeBtn.dataset.bound = true;
    }
  });
});

const drawerContent = document.querySelector('.custom-view-all-drawer .drawer__content');
const drawerHeader = document.querySelector('.custom-view-all-drawer header.drawer__header');

if (drawerContent && drawerHeader) {
  let isScrolling;

  drawerContent.addEventListener('scroll', () => {
    // Add box-shadow while scrolling
    drawerHeader.classList.add('is-scrolling');

    // Clear timeout if already running
    clearTimeout(isScrolling);

    // Remove box-shadow after scrolling stops (e.g., 150ms)
    isScrolling = setTimeout(() => {
      drawerHeader.classList.remove('is-scrolling');
    }, 150);
  });
}


// custom view all drawer ends here

// for single variant to show ship message starts 

// this part of code is used to display shipping date even if windows gets reload

  // function getVariantIdFromUrl(url) {
  //   const params = new URLSearchParams(new URL(url).search);
  //   return params.get('variant');
  // }

  // function showSingleOrSelectedVariant() {
  //   const variantTimes = document.querySelectorAll('.variant-time');
    
  //   // Hide all initially
  //   variantTimes.forEach(v => v.style.display = 'none');

  //   if (variantTimes.length === 1) {
  //     // Only one variant — always show it
  //     variantTimes[0].style.display = 'flex';
  //   } else {
  //     // Multiple variants — show based on selected variant ID
  //     const currentVariantId = getVariantIdFromUrl(window.location.href);
  //     variantTimes.forEach((v) => {
  //       if (v.id === currentVariantId) {
  //         v.style.display = 'flex';
  //       }
  //     });
  //   }
  // }

  // function checkVariantIdChange(callback) {
  //   let currentVariantId = getVariantIdFromUrl(window.location.href);
  //   setInterval(function () {
  //     const newVariantId = getVariantIdFromUrl(window.location.href);
  //     if (newVariantId !== currentVariantId) {
  //       currentVariantId = newVariantId;
  //       callback();
  //     }
  //   }, 100);
  // }

  // showSingleOrSelectedVariant();
  // checkVariantIdChange(showSingleOrSelectedVariant);

// this part of code is used to display shipping date even if windows gets reload end

// for single variant to show ship message ends

// disable add to cart button for varaint selection message starts here

document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector('#AddToCart');
  const radioButtons = document.querySelectorAll('.product-form__option-selector .custom-pdp-accordion input[type="radio"]');
  const comboBoxButtons = document.querySelectorAll('.combo-box__option-item');
  const selectButtons = document.querySelectorAll('.mjkloip.select .weweew');
  const hasOnlyDefaultVariant = document.querySelector('[data-has-only-default-variant="true"]');
  const optionLabel = document.querySelector('.custom-pdp-accordion .product-form__option-name') || document.querySelector('.mjkloip.select .weweew');
  
  let isVariantSelected = false;

  function showAlert() {
    if (!optionLabel) {
      console.warn('[Alert] No label element found to attach alert');
      return;
    }
    // Remove any existing alert first
    removeAlert();
    
    const labelText = optionLabel.innerText.trim() || 'an option';
    const alert = document.createElement('div');
    alert.className = 'variant-alert';
    alert.style.color = '#EB573F';
    alert.style.display = 'flex';
    alert.style.alignItems = 'center';
    alert.style.gap = '6px';
    alert.style.fontSize = '10px';
    alert.style.marginTop = '5px';
    alert.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
        <path d="M11 5.5C11 8.53368 8.53368 11 5.5 11C2.46632 11 0 8.53368 0 5.5C0 2.46632 2.46632 0 5.5 0C8.53368 0 11 2.46632 11 5.5ZM5.5 0.868421C2.94105 0.868421 0.868421 2.94105 0.868421 5.5C0.868421 8.05895 2.94105 10.1316 5.5 10.1316C8.05895 10.1316 10.1316 8.05895 10.1316 5.5C10.1316 2.94105 8.05895 0.868421 5.5 0.868421ZM6.07895 8.34842V4.87474C6.07895 4.55053 5.82421 4.29579 5.5 4.29579C5.17579 4.29579 4.92105 4.55053 4.92105 4.87474V8.34842C4.92105 8.67263 5.17579 8.92737 5.5 8.92737C5.82421 8.92737 6.07895 8.67263 6.07895 8.34842ZM5.5 2.07263C5.04842 2.07263 4.68947 2.43158 4.68947 2.88316C4.68947 3.33474 5.04842 3.69368 5.5 3.69368C5.95158 3.69368 6.31053 3.33474 6.31053 2.88316C6.31053 2.43158 5.95158 2.07263 5.5 2.07263Z" fill="#EB573F"/>
      </svg>
      <span>SELECTEER ${labelText}</span>
    `;
    optionLabel.appendChild(alert);
  }

  function removeAlert() {
    const existing = optionLabel?.querySelector('.variant-alert');
    if (existing) {
      existing.remove();
    }
  }

  function handleVariantSelection() {
    isVariantSelected = true;
    removeAlert();
  }

  function handleAddToCart(event) {
    if (!hasOnlyDefaultVariant && !isVariantSelected) {
      event.preventDefault();
      event.stopPropagation();
      showAlert();
      return false;
    }
    return true;
  }

  function init() {
    // Reset all radio buttons
    radioButtons.forEach(radio => {
      radio.checked = false;
    });
    
    // Initialize variant selection state
    if (!hasOnlyDefaultVariant && (radioButtons.length > 0 || comboBoxButtons.length > 0 || selectButtons.length > 0)) {
      isVariantSelected = false;
    } else {
      isVariantSelected = true;
    }

    // Add click handler to Add to Cart button
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', handleAddToCart);
    }

    // Set up variant selection handlers
    radioButtons.forEach(radio => {
      radio.addEventListener('change', handleVariantSelection);
    });

    comboBoxButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        this.parentElement.querySelectorAll('.combo-box__option-item').forEach(el => el.setAttribute('aria-selected', 'false'));
        this.setAttribute('aria-selected', 'true');
        handleVariantSelection();
      });
    });

    selectButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        selectButtons.forEach(el => el.classList.remove('selected'));
        this.classList.add('selected');
        handleVariantSelection();
      });
    });
  }

  init();
});

// disable add to cart button for varaint selection message ends here


// update price and change comma into dot starts here

document.addEventListener('variant:changed', function () {
  const productPrices = document.querySelector("[data-product-price-list]");
  if (!productPrices) return;

  // Replace all commas with dots in the price display
  productPrices.innerHTML = productPrices.innerHTML.replace(/,/g, '.');
});

// update price and change comma into dot starts here

document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.getElementById("mobile-menu-drawer");
  const links = drawer?.querySelectorAll(".mobile-nav__linkss");

  links?.forEach(link => {
    link.addEventListener("click", function () {
      drawer.scrollTop = 0; // reset scroll inside drawer
    });
  });
});


$(document).on('click', '.custom_filter.custom_filter___text', function() {
  var id = $(this).attr('aria-controls');
  // Close all other filters
  $("facet-filters button.collapsible-toggle").not(this).attr("aria-expanded", "false")
    .next().css("overflow", "hidden").removeAttr("open");

  // Open the clicked one
  $("facet-filters button.collapsible-toggle[aria-controls='"+id+"']").attr("aria-expanded", "true")
    .next().css("overflow", "visible").attr("open", true);

  $("facet-filters").attr("open", true);
});


// sticky sub categories starts here

document.addEventListener("DOMContentLoaded", function () {
  const stickyEl = document.querySelector(".sticky-sub-categories");
  const anchorEl = document.querySelector(".product-facet__meta-bar.anchor");

  if (!stickyEl || !anchorEl) return;

  // Initialize display to none
  stickyEl.style.display = "none";

  // Debounce function to limit scroll event frequency
  function debounce(func, wait) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), wait);
    };
  }

  function handleScroll() {
    const anchorRect = anchorEl.getBoundingClientRect();
    const buffer = 1; // Small buffer to prevent rapid toggling

    if (anchorRect.top < buffer) {
      stickyEl.style.display = "block"; // Use block instead of empty string for clarity
      stickyEl.classList.add("sticky-subcategories");
    } else {
      stickyEl.classList.remove("sticky-subcategories");
      stickyEl.style.display = "none";
    }
  }

  // Debounce scroll handler to fire every 100ms
  const debouncedHandleScroll = debounce(handleScroll, 20);
  window.addEventListener("scroll", debouncedHandleScroll);
});



// sticky sub categories ends here

// show shipping status for single variant starts here
function showSingleOrSelectedVariant() {
  const variantTimes = document.querySelectorAll('.variant-time');
  if (variantTimes.length === 1) {
    variantTimes[0].style.display = 'flex';
  }
}
showSingleOrSelectedVariant();
// show shipping status for single variant starts here

// product info dropdown code starts here
document.addEventListener('DOMContentLoaded', () => {
  const parentContainer = document.querySelector('.product__info');

  // Use event delegation on the parent container
  parentContainer.addEventListener('click', (event) => {
    const toggle = event.target.closest('.faq__Data .collapsible-toggle');
    if (!toggle) return; // Exit if click is not on a toggle button

    event.stopImmediatePropagation(); // Prevent other scripts from handling this click
    event.preventDefault(); // Prevent default behavior to avoid interference

    const targetId = toggle.getAttribute('aria-controls');
    const targetContent = document.getElementById(targetId);
    if (!targetContent) {
      console.warn(`No content found for aria-controls="${targetId}"`);
      return; // Exit if target content is not found
    }

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const newExpandedState = !isExpanded;

    // Batch DOM updates to minimize reflows
    requestAnimationFrame(() => {
      // Close all other accordions within .product__info
      parentContainer.querySelectorAll('.faq__Data .collapsible-toggle').forEach(otherToggle => {
        if (otherToggle !== toggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
          const otherId = otherToggle.getAttribute('aria-controls');
          const otherContent = document.getElementById(otherId);
          if (otherContent) {
            otherContent.removeAttribute('open');
          }
        }
      });

      // Toggle the clicked accordion
      toggle.setAttribute('aria-expanded', newExpandedState ? 'true' : 'false');
      if (newExpandedState) {
        targetContent.setAttribute('open', '');
      } else {
        targetContent.removeAttribute('open');
      }
    });
  }, { capture: true }); // Use capture phase to prioritize our listener
});
// product info dropdown code ends here


// custom swatch linked product code starts here

document.addEventListener('DOMContentLoaded', () => {
  // Run immediately
  initProductCards(document);

  // === ENHANCED: Observe multiple possible grid containers ===
  const gridSelectors = [
    '.collection__grid',
    '.product-grid',
    '.grid',
    '.products',
    '[data-section-type="collection"]',
    '.shopify-section'
  ];

  const observeGrids = () => {
    gridSelectors.forEach(selector => {
      const grids = document.querySelectorAll(selector);
      grids.forEach(grid => {
        if (!grid.dataset.observed) {
          grid.dataset.observed = 'true';
          observer.observe(grid, { childList: true, subtree: true });
        }
      });
    });
  };

  // === Mutation Observer (now smarter) ===
  const observer = new MutationObserver(mutations => {
    let shouldInit = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches('.product-item') || node.querySelector('.product-item')) {
            shouldInit = true;
          }
        }
      });
    });
    if (shouldInit) {
      // Small delay to ensure DOM is ready
      requestAnimationFrame(() => initProductCards(document));
    }
  });

  // Start observing body + known grids
  observer.observe(document.body, { childList: true, subtree: true });
  observeGrids();

  // === Fallback: Click on "Load More" buttons ===
  document.addEventListener('click', (e) => {
    const loadMoreBtn = e.target.closest('button, a, [role="button"]');
    if (!loadMoreBtn) return;

    const btnText = (loadMoreBtn.textContent || '').toLowerCase();
    const isLoadMore = /load more|show more|see more|next/i.test(btnText);

    if (isLoadMore) {
      // Re-init after a short delay (wait for new products)
      setTimeout(() => {
        initProductCards(document);
        observeGrids(); // Re-observe new grids if added
      }, 800);
    }
  });

  // ----------------------------
  // Core Functions (unchanged)
  // ----------------------------
  function initProductCards(context) {
    const productCards = context.querySelectorAll('.product-item');
    productCards.forEach(productCard => {
      if (productCard.dataset.swatchesInitialized === 'true') return;
      productCard.dataset.swatchesInitialized = 'true';

      const swatchesContainer = productCard.querySelector('.product-item-meta__swatch-list');
      if (!swatchesContainer) return;

      const swatches = Array.from(swatchesContainer.querySelectorAll('.color-swatch'));
      if (swatches.length === 0) return;

      const titleElement = productCard.querySelector('.product-item-meta__title');
      const currentProductTitle = titleElement ? (titleElement.textContent || '').trim() : '';

      // Reorder: match title → first swatch
      if (currentProductTitle) {
        const matchedIndex = swatches.findIndex(swatch => {
          const radio = swatch.querySelector('.color-swatch__radio');
          return radio && radio.dataset.productName && radio.dataset.productName.trim() === currentProductTitle;
        });

        if (matchedIndex > -1) {
          const [matchedSwatch] = swatches.splice(matchedIndex, 1);
          swatches.unshift(matchedSwatch);
          swatches.forEach(swatch => swatchesContainer.appendChild(swatch));
        }
      }

      // Reset
      swatches.forEach(swatch => {
        const input = swatch.querySelector('.color-swatch__radio');
        if (input) input.checked = false;
        swatch.classList.remove('is-active');
      });

      // Activate first
      const firstSwatch = swatches[0];
      const firstInput = firstSwatch.querySelector('.color-swatch__radio');
      if (firstInput) {
        firstInput.checked = true;
        firstSwatch.classList.add('is-active');
        updateProductCard(productCard, firstInput);
      }

      // Click handlers
      swatches.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          const input = swatch.querySelector('.color-swatch__radio');
          if (!input) return;

          swatches.forEach(s => {
            const i = s.querySelector('.color-swatch__radio');
            if (i) i.checked = false;
            s.classList.remove('is-active');
          });

          input.checked = true;
          swatch.classList.add('is-active');
          updateProductCard(productCard, input);
        });
      });
    });
  }

  function updateProductCard(productCard, input) {
    const { productImage, productSecondImage, productTitle, productPrice, productLink, productPriceCompare } = input.dataset;
    const primaryImage = productCard.querySelector('.product-item__primary-image');
    if (primaryImage && productImage) {
      primaryImage.src = productImage;
      primaryImage.srcset = productImage;
    }
    const secondaryImage = productCard.querySelector('.product-item__secondary-image');
    if (secondaryImage && productSecondImage) {
      secondaryImage.src = productSecondImage;
      secondaryImage.srcset = productSecondImage;
    }
    const titleLink = productCard.querySelector('.product-item-meta__title');
    if (titleLink && productLink) {
      titleLink.href = productLink;
      titleLink.textContent = productTitle;
    }
    const aspectRatioLink = productCard.querySelector('.product-item__aspect-ratio');
    if (aspectRatioLink && productLink) {
      aspectRatioLink.href = productLink;
    }
    const priceElement = productCard.querySelector('.product-item-meta__price-list-container .price');
    if (priceElement && productPrice) {
      priceElement.textContent = productPrice;
    }

    const priceElementcompare = productCard.querySelector('.product-item-meta__price-list-container .price--compare');
    if (priceElementcompare && productPriceCompare) {
      priceElementcompare.textContent = productPriceCompare;
    }

    // --- NEW LOGIC: UPDATE DISCOUNT PERCENTAGE ---
    const discountEl = productCard.querySelector('.discount-percentage');
    if (discountEl && productPrice && productPriceCompare) {
      // Convert €718 → 718   OR "€718.00" → 718
      const cleanPrice = parseFloat(productPrice.replace(/[^0-9.]/g, ''));
      const cleanCompare = parseFloat(productPriceCompare.replace(/[^0-9.]/g, ''));

      if (cleanCompare > cleanPrice) {
        const discountPercent = Math.round(((cleanCompare - cleanPrice) / cleanCompare) * 100);
        discountEl.textContent = `${discountPercent}% OFF`;

        // Optional: update attributes
        discountEl.setAttribute("current_price", cleanPrice * 100);
        discountEl.setAttribute("compare_price", cleanCompare * 100);
        discountEl.setAttribute("discount", (cleanCompare - cleanPrice) * 100);
      } else {
        // No discount case
        // discountEl.textContent = "";
      }
    }

  }
});

// custom swatch linked product code ends here



// earing/necklace template js for shipping starts here
(function () {
  // Templates to support
  const TEMPLATE_SELECTOR = '.template-product-earrings, .template-product-necklace';

  // Initialize one controller per template root element
  function initTemplate(root) {
    if (!root) return;

    // Container containing .vtc blocks for this root
    const container = root.querySelector('.estimated-time');
    if (!container) return;

    // Build label -> variantId map for this root only
    function buildMap() {
      const map = {};
      // Possible locations of the select inside this root
      const selectors = [
        'product-variants noscript select',
        'product-variants template select',
        'product-variants select',
        'select[name="id"]'
      ];

      let select = null;
      for (const sel of selectors) {
        select = root.querySelector(sel);
        if (select) break;
      }

      // fallback: parse noscript text if present
      if (!select) {
        const noscript = root.querySelector('product-variants noscript');
        if (noscript) {
          const div = document.createElement('div');
          div.innerHTML = noscript.textContent;
          select = div.querySelector('select');
        }
      }

      if (select) {
        Array.from(select.options).forEach(opt => {
          const text = opt.textContent.trim();
          const label = text.split(' ')[0];
          map[label] = opt.value;
        });
      }

      // debug
      // console.log('Variant map rebuilt for root:', map);
      return map;
    }

    // Get current vtc blocks for this root
    function getVtcs() {
      return Array.from(container.querySelectorAll('.vtc'));
    }

    // Hide all and show the matching one (search within this root)
    function showById(variantId) {
      const vtcs = getVtcs();
      vtcs.forEach(v => (v.style.display = 'none'));
      if (!variantId) return;
      // prefer element within this root
      const el = container.querySelector(`#${CSS.escape(variantId)}`);
      if (el) el.style.display = 'flex';
    }

    // Read variant from URL and show the matching block if it belongs to this root
    function syncFromUrl() {
      const params = new URLSearchParams(location.search);
      const vid = params.get('variant');
      if (!vid) return;
      // Only show if this root contains the element
      if (container.querySelector(`#${CSS.escape(vid)}`)) {
        showById(vid);
      }
    }

    // Attach radio listeners scoped to this root
    function attachRadioListeners(labelToId) {
      const radios = root.querySelectorAll('input[name="option1"]');
      radios.forEach(radio => {
        // ensure we remove a previously bound listener (safe)
        radio.removeEventListener('change', radio._changeHandler);
        const handler = function (e) {
          if (!e.target.checked) return;
          const label = e.target.value;
          const variantId = labelToId[label];
          if (!variantId) {
            console.warn('No variant ID for label:', label);
            return;
          }
          const url = new URL(location);
          url.searchParams.set('variant', variantId);
          history.replaceState(null, '', url);
          showById(variantId);
        };
        // store on element so we can remove it later
        radio._changeHandler = handler;
        radio.addEventListener('change', handler);
      });
    }

    // Keep map up to date and (re)attach listeners
    let labelToId = buildMap();
    attachRadioListeners(labelToId);
    syncFromUrl();

    // Observe DOM changes inside this root and rebuild map / rebind listeners
    const observer = new MutationObserver(() => {
      labelToId = buildMap();
      attachRadioListeners(labelToId);
      // if URL already set, ensure visible block is correct after DOM change
      syncFromUrl();
    });

    observer.observe(root, { childList: true, subtree: true });

    // When history navigation occurs, sync as well
    const popHandler = () => syncFromUrl();
    window.addEventListener('popstate', popHandler);

    // return cleanup handle in case we want to stop observing later
    return {
      destroy() {
        observer.disconnect();
        window.removeEventListener('popstate', popHandler);
        // remove listeners added to radios
        const radios = root.querySelectorAll('input[name="option1"]');
        radios.forEach(r => r.removeEventListener('change', r._changeHandler));
      }
    };
  }

  // Initialize for every matching template in the page
  const instances = [];
  document.querySelectorAll(TEMPLATE_SELECTOR).forEach(root => {
    instances.push(initTemplate(root));
  });

  // In case templates are dynamically added later, watch document and init them
  const globalObserver = new MutationObserver(mutations => {
    for (const m of mutations) {
      m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches(TEMPLATE_SELECTOR)) {
          instances.push(initTemplate(node));
        } else {
          // maybe a template was added deeper — try to find any inside
          node.querySelectorAll && node.querySelectorAll(TEMPLATE_SELECTOR).forEach(root => {
            instances.push(initTemplate(root));
          });
        }
      });
    }
  });

  globalObserver.observe(document.body, { childList: true, subtree: true });
})();



// earing/necklace template js for shipping ends here


// on click of trustpilot icon , scrolls to its section starts here

document.addEventListener("DOMContentLoaded", function () {
  const link = document.querySelector('a[href="#trustpilot-section-id"]');
  if (!link) return;

  link.addEventListener("click", function (e) {
    e.preventDefault();
    const target = document.querySelector("#trustpilot-section-id");
    if (!target) return;

    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});

// on click of trustpilot icon , scrolls to its section ends here


// cart ups slider starts here

window.uspsSwiper = null;
function initUspsSlider() {
  const slider = document.querySelector('.cd-usps-slider');
  if (!slider) return;
  if (window.uspsSwiper && typeof window.uspsSwiper.destroy === 'function') {
    window.uspsSwiper.destroy(true, true);
    window.uspsSwiper = undefined;
  }
  if (slider.classList.contains('swiper-initialized')) {
    return;
  }
  window.uspsSwiper = new Swiper(slider, {
    loop: true,
    autoplay: true,
    speed: 800,
    pagination: {
      el: slider.querySelector('.swiper-pagination'),
      clickable: true,
    },
    breakpoints: {
      320: { slidesPerView: 1 },
      768: { slidesPerView: 1 },
      1024: { slidesPerView: 1 }
    }
  });
}
document.addEventListener('DOMContentLoaded', function () {
  initUspsSlider();
});
document.documentElement.addEventListener('cart:refresh', function () {
  setTimeout(initUspsSlider, 1000);
});
document.documentElement.addEventListener('theme:refresh', function () {
  setTimeout(initUspsSlider, 1000);
});

// cart ups slider ends here

// script for hide shipping info when sold out starts here
$(document).on("click", ".combo-box__option-item", function () {
  const text = $(this).text().trim().toLowerCase();
  const estimatedTime = $(".estimated-time");
  if (text.includes("uitverkocht") || text.includes("sold out")) {
    estimatedTime.addClass("hide-shipping");
  } else {
    estimatedTime.removeClass("hide-shipping");
  }
});

// script for hide shipping info when sold out ends here





// line item property in checkout starts 


document.addEventListener("DOMContentLoaded", function () {
  const estimatedTimeContainer = document.querySelector(".estimated-time");

  if (!estimatedTimeContainer) return;

  function getCurrentShippingText() {
    let active = estimatedTimeContainer.querySelector(".variant-time[style*='display: flex']");

    if (!active) {
      const variantBlocks = estimatedTimeContainer.querySelectorAll(".variant-time");
      if (variantBlocks.length > 0) {
        active = variantBlocks[0];
      }
    }

    if (!active) return null;

    return active.innerText.trim();
  }

  function updateLineItemProperty() {
    const shippingText = getCurrentShippingText();
    if (!shippingText) return;

    let propertyInput = document.querySelector("input[name='properties[Verzendinformatie]']");

    if (!propertyInput) {
      const form = document.querySelector("form[action*='/cart/add']");
      if (!form) return;

      propertyInput = document.createElement("input");
      propertyInput.type = "hidden";
      propertyInput.name = "properties[Verzendinformatie]";
      form.appendChild(propertyInput);
    }

    propertyInput.value = shippingText;
  }

  const observer = new MutationObserver(() => {
    updateLineItemProperty();
  });

  observer.observe(estimatedTimeContainer, {
    attributes: true,
    subtree: true,
    attributeFilter: ["style"],
  });

  updateLineItemProperty();
});


// line item property in checkout ends





/**
 * GALLERY IMAGE UPDATE ON VARIANT CHANGE
 * This ensures gallery images update when swatches/variants are clicked
 * This is a backup/fallback to ensure gallery updates work even if theme.js has issues
 * This preserves the original gallery functionality from theme.js
 */
(function () {
  'use strict';

  // Galleries grouped with #tags in the alt texts are handled in product-gallery.liquid; leave them alone here.
  function isVariantGallery() {
    return !!document.querySelector('product-media[data-variant-gallery]');
  }

  // Store the last updated variant to prevent duplicate updates
  let lastUpdatedVariantId = null;
  let lastUpdatedMediaId = null;

  /**
   * Main handler for variant:changed event
   * This replicates and enhances the original ProductMedia._onVariantChanged functionality
   */
  function handleVariantChanged(event) {
    if (isVariantGallery()) return;
    const variant = event.detail?.variant;
    if (!variant) {
      console.warn('[Gallery Update] No variant in event detail');
      return;
    }

    // Prevent duplicate updates
    if (lastUpdatedVariantId === variant.id && variant.featured_media?.id === lastUpdatedMediaId) {
      return;
    }

    // Debug logging (set to false in production)
    const DEBUG = false;
    if (DEBUG) {
      console.log('[Gallery Update] Variant changed:', {
        variantId: variant.id,
        featuredMediaId: variant.featured_media?.id,
        variantTitle: variant.title
      });
    }

    // Find the product-media element
    const productMedia = document.querySelector('product-media.product__media');
    if (!productMedia) {
      console.warn('[Gallery Update] Product media element not found');
      return;
    }

    // Get the featured media ID from variant
    const featuredMediaId = variant.featured_media?.id;
    if (!featuredMediaId) {
      console.warn('[Gallery Update] Variant has no featured media, variant ID:', variant.id);
      // Still try to update if we can find a matching media item
      updateGalleryByVariantOptions(productMedia, variant);
      return;
    }

    // Update the gallery
    updateGalleryImage(productMedia, featuredMediaId, variant);

    // Store last updated IDs
    lastUpdatedVariantId = variant.id;
    lastUpdatedMediaId = featuredMediaId;

    // After gallery updates, reorder ALL matching color images to the front
    // This runs on a delay to ensure it executes AFTER single-image gallery updates
    // Translation-safe: reads color from featured media's data-alt-image (not swatch value)
    setTimeout(() => {
      const colorFromMedia = getColorFromMediaItem(productMedia, featuredMediaId);
      if (colorFromMedia) {
        reorderMediaBySwatchColor(productMedia, colorFromMedia);
      } else {
        // Fallback: try swatch value if data-alt-image approach fails
        const form = document.querySelector('form[id^="product-form"]');
        if (form) {
          const checkedSwatch = form.querySelector('.block-swatch__radio:checked, .color-swatch__radio:checked, .variant-swatch__radio:checked');
          if (checkedSwatch) {
            reorderMediaBySwatchColor(productMedia, checkedSwatch.value);
          }
        }
      }
    }, 300);
  }

  /**
   * Main gallery update function
   * Tries multiple methods to ensure the gallery updates
   */
  function updateGalleryImage(productMedia, featuredMediaId, variant) {
    if (isVariantGallery()) return;
    const DEBUG = false;
    if (DEBUG) console.log('[Gallery Update] Starting gallery update for media ID:', featuredMediaId);

    // Method 1: Try Glide carousel first (since that's what's being used)
    if (updateGalleryViaGlide(productMedia, featuredMediaId)) {
      if (DEBUG) console.log('[Gallery Update] Successfully updated via Glide carousel');
      return;
    }

    // Method 2: Try to use the mainCarousel from ProductMedia (original theme.js method)
    if (productMedia.mainCarousel) {
      const mediaSelector = `[data-media-id="${featuredMediaId}"]`;
      if (DEBUG) console.log('[Gallery Update] Attempting mainCarousel.select:', mediaSelector);

      try {
        // Check if select method exists and is callable
        if (typeof productMedia.mainCarousel.select === 'function') {
          productMedia.mainCarousel.select(mediaSelector);
          if (DEBUG) console.log('[Gallery Update] Successfully used mainCarousel.select');
          return;
        }
      } catch (e) {
        if (DEBUG) console.warn('[Gallery Update] mainCarousel.select failed:', e);
      }
    }

    // Method 3: Try flickity-carousel element directly
    updateGalleryViaFlickity(productMedia, featuredMediaId);

    // Method 4: Direct DOM manipulation (fallback)
    updateGalleryViaDOM(productMedia, featuredMediaId, variant);
  }

  /**
   * Update gallery using Flickity carousel
   */
  function updateGalleryViaFlickity(productMedia, featuredMediaId) {
    const DEBUG = false;
    const flickityCarousel = productMedia.querySelector('flickity-carousel');
    if (!flickityCarousel) {
      if (DEBUG) console.warn('[Gallery Update] Flickity carousel element not found');
      return;
    }

    const mediaSelector = `[data-media-id="${featuredMediaId}"]`;

    // Try to get flickity instance
    if (flickityCarousel.flickityInstance) {
      flickityCarousel.flickityInstance
        .then(instance => {
          if (DEBUG) console.log('[Gallery Update] Using flickity instance to select:', mediaSelector);
          try {
            if (instance.selectCell) {
              instance.selectCell(mediaSelector);
            } else if (instance.select) {
              instance.select(mediaSelector);
            }
          } catch (e) {
            if (DEBUG) console.warn('[Gallery Update] Flickity instance select failed:', e);
          }
        })
        .catch(err => {
          if (DEBUG) console.warn('[Gallery Update] Error getting flickity instance:', err);
        });
    } else if (typeof flickityCarousel.select === 'function') {
      // Try select method directly on flickity-carousel
      try {
        flickityCarousel.select(mediaSelector);
        if (DEBUG) console.log('[Gallery Update] Successfully used flickity-carousel.select');
      } catch (e) {
        if (DEBUG) console.warn('[Gallery Update] flickity-carousel.select failed:', e);
      }
    }
  }

  /**
   * Update gallery using Glide.js carousel
   * This handles the Glide carousel structure used in some product templates
   */
  function updateGalleryViaGlide(productMedia, featuredMediaId) {
    const DEBUG = false;
    if (DEBUG) console.log('[Gallery Update] Attempting Glide carousel update for media ID:', featuredMediaId);

    // Find Glide carousel elements
    const glideTrack = productMedia.querySelector('.glide__track');
    const glideSlides = productMedia.querySelector('.glide__slides');

    if (!glideSlides) {
      if (DEBUG) console.log('[Gallery Update] Glide slides not found');
      return false;
    }

    // Find all glide slides
    const allSlides = glideSlides.querySelectorAll('.glide__slide[data-media-id]');

    if (allSlides.length === 0) {
      if (DEBUG) console.log('[Gallery Update] No Glide slides with data-media-id found');
      return false;
    }

    // The data-media-id format is "section.id-media.id" (e.g., "template--28348788965714__main-50771805372754")
    // We need to find the slide that contains this media ID
    let targetSlide = null;
    let slideIndex = -1;

    // Try multiple matching strategies
    // Strategy 1: Exact match
    targetSlide = Array.from(allSlides).find(slide => {
      const mediaIdAttr = slide.getAttribute('data-media-id');
      return mediaIdAttr === String(featuredMediaId);
    });

    // Strategy 2: Ends with "-{mediaId}"
    if (!targetSlide) {
      targetSlide = Array.from(allSlides).find(slide => {
        const mediaIdAttr = slide.getAttribute('data-media-id');
        return mediaIdAttr && mediaIdAttr.endsWith(`-${featuredMediaId}`);
      });
    }

    // Strategy 3: Contains the media ID
    if (!targetSlide) {
      targetSlide = Array.from(allSlides).find(slide => {
        const mediaIdAttr = slide.getAttribute('data-media-id');
        return mediaIdAttr && (mediaIdAttr.includes(`-${featuredMediaId}`) || mediaIdAttr.includes(featuredMediaId));
      });
    }

    // Strategy 4: Match just the numeric part at the end
    if (!targetSlide) {
      const numericId = String(featuredMediaId).replace(/^.*-/, ''); // Get last part after dash
      targetSlide = Array.from(allSlides).find(slide => {
        const mediaIdAttr = slide.getAttribute('data-media-id');
        return mediaIdAttr && (mediaIdAttr.endsWith(`-${numericId}`) || mediaIdAttr === numericId);
      });
    }

    if (!targetSlide) {
      if (DEBUG) console.warn('[Gallery Update] Glide slide not found for media ID:', featuredMediaId);
      // Log all available media IDs for debugging
      if (DEBUG) {
        const availableIds = Array.from(allSlides).map(s => s.getAttribute('data-media-id'));
        console.log('[Gallery Update] Available media IDs:', availableIds);
      }
      return false;
    }

    // Find the index of the target slide
    slideIndex = Array.from(allSlides).indexOf(targetSlide);
    if (DEBUG) console.log('[Gallery Update] Found slide at index:', slideIndex);

    // Move the target slide to the first position (don't hide others)
    if (targetSlide && glideSlides) {
      // Remove target slide from its current position
      targetSlide.remove();
      // Insert it at the beginning
      glideSlides.insertBefore(targetSlide, glideSlides.firstChild);
      if (DEBUG) console.log('[Gallery Update] Moved slide to first position');

      // Update active classes - mark first slide as active
      const updatedSlides = glideSlides.querySelectorAll('.glide__slide');
      updatedSlides.forEach((slide, index) => {
        if (index === 0) {
          slide.classList.add('is-active', 'is-selected');
        } else {
          slide.classList.remove('is-active', 'is-selected');
        }
      });

      // Try to go to first slide using carousel API
      const carousel = productMedia.querySelector('#mainProductCarousel, .carousel');
      if (carousel && carousel._glide) {
        try {
          carousel._glide.go('=0');
          if (DEBUG) console.log('[Gallery Update] Used Glide.go to first slide');
          return true;
        } catch (e) {
          if (DEBUG) console.warn('[Gallery Update] Glide.go failed:', e);
        }
      } else if (typeof $ !== 'undefined' && $('#mainProductCarousel').hasClass('slick-initialized')) {
        try {
          $('#mainProductCarousel').slick('slickGoTo', 0, true);
          if (DEBUG) console.log('[Gallery Update] Used Slick to first slide');
          return true;
        } catch (e) {
          if (DEBUG) console.warn('[Gallery Update] Slick failed:', e);
        }
      }

      return true;
    }

    return false;
  }

  /**
   * Update gallery using direct DOM manipulation
   * This is the most reliable fallback method
   */
  function updateGalleryViaDOM(productMedia, featuredMediaId, variant) {
    if (isVariantGallery()) return;
    const DEBUG = false;
    if (DEBUG) console.log('[Gallery Update] Using direct DOM manipulation for media ID:', featuredMediaId);

    // First try Glide carousel
    if (updateGalleryViaGlide(productMedia, featuredMediaId)) {
      if (DEBUG) console.log('[Gallery Update] Successfully updated via Glide');
      return;
    }

    // Find all media items (Flickity structure)
    const allMediaItems = productMedia.querySelectorAll('.product__media-item[data-media-id]');
    let targetMediaItem = productMedia.querySelector(`.product__media-item[data-media-id="${featuredMediaId}"]`);

    // If not found, try to find by media ID that ends with the featuredMediaId
    if (!targetMediaItem) {
      targetMediaItem = Array.from(allMediaItems).find(item => {
        const mediaIdAttr = item.getAttribute('data-media-id');
        return mediaIdAttr && (mediaIdAttr === String(featuredMediaId) || mediaIdAttr.endsWith(`-${featuredMediaId}`));
      });
    }

    // Also check Glide slides
    let glideSlide = null;
    const glideSlidesContainer = productMedia.querySelector('.glide__slides');
    if (glideSlidesContainer) {
      const glideSlides = glideSlidesContainer.querySelectorAll('.glide__slide[data-media-id]');
      glideSlide = Array.from(glideSlides).find(slide => {
        const mediaIdAttr = slide.getAttribute('data-media-id');
        return mediaIdAttr && (mediaIdAttr === String(featuredMediaId) || mediaIdAttr.endsWith(`-${featuredMediaId}`) || mediaIdAttr.includes(`-${featuredMediaId}`));
      });
    }

    // If we found a Glide slide, move it to first position
    if (glideSlide && glideSlidesContainer) {
      if (DEBUG) console.log('[Gallery Update] Found Glide slide, moving to first position');

      // Remove the slide from its current position
      glideSlide.remove();
      // Insert it at the beginning
      glideSlidesContainer.insertBefore(glideSlide, glideSlidesContainer.firstChild);

      // Update active classes - mark first slide as active
      const allGlideSlides = glideSlidesContainer.querySelectorAll('.glide__slide');
      allGlideSlides.forEach((slide, index) => {
        if (index === 0) {
          slide.classList.add('is-active', 'is-selected');
        } else {
          slide.classList.remove('is-active', 'is-selected');
        }
      });

      // Try to go to first slide using carousel API
      const carousel = productMedia.querySelector('#mainProductCarousel, .carousel');
      if (carousel && carousel._glide) {
        try {
          carousel._glide.go('=0');
          if (DEBUG) console.log('[Gallery Update] Used Glide.go to first slide');
        } catch (e) {
          if (DEBUG) console.warn('[Gallery Update] Glide.go failed:', e);
        }
      } else if (typeof $ !== 'undefined' && $('#mainProductCarousel').hasClass('slick-initialized')) {
        try {
          $('#mainProductCarousel').slick('slickGoTo', 0, true);
          if (DEBUG) console.log('[Gallery Update] Used Slick to first slide');
        } catch (e) {
          if (DEBUG) console.warn('[Gallery Update] Slick failed:', e);
        }
      }

      return;
    }

    if (!targetMediaItem) {
      console.warn('[Gallery Update] Media item not found with ID:', featuredMediaId);
      // Log available IDs for debugging
      if (DEBUG) {
        const availableIds = Array.from(allMediaItems).map(item => item.getAttribute('data-media-id'));
        const glideIds = Array.from(productMedia.querySelectorAll('.glide__slide[data-media-id]')).map(slide => slide.getAttribute('data-media-id'));
        console.log('[Gallery Update] Available Flickity media IDs:', availableIds);
        console.log('[Gallery Update] Available Glide media IDs:', glideIds);
      }
      return;
    }

    // For Flickity structure: move to first position instead of hiding
    // Remove selected classes from all items
    allMediaItems.forEach(item => {
      item.classList.remove('is-selected', 'is-initial-selected', 'is-active');
    });

    // Remove filtered class and add selected classes to target
    targetMediaItem.classList.remove('is-filtered');
    targetMediaItem.classList.add('is-selected', 'is-initial-selected', 'is-active');

    // Move target item to first position in the container — not in the swipe gallery (mobile), which keeps its order
    // so the position dots stay right; product-gallery.liquid scrolls to the variant image there instead.
    const mediaContainer = targetMediaItem.parentElement;
    if (mediaContainer && targetMediaItem !== mediaContainer.firstElementChild && !isSwipeGallery(mediaContainer)) {
      mediaContainer.insertBefore(targetMediaItem, mediaContainer.firstChild);
      if (DEBUG) console.log('[Gallery Update] Moved Flickity media item to first position');
    }

    // Try to reload carousel if it exists (Flickity)
    const flickityCarousel = productMedia.querySelector('flickity-carousel');
    if (flickityCarousel) {
      // Try reload method
      if (typeof flickityCarousel.reload === 'function') {
        try {
          flickityCarousel.reload();
        } catch (e) {
          console.warn('[Gallery Update] Carousel reload failed:', e);
        }
      }
    }

    // Scroll the item into view with a slight delay to ensure DOM is updated
    // setTimeout(() => {
    //   try {
    //     targetMediaItem.scrollIntoView({
    //       behavior: 'smooth',
    //       block: 'nearest',
    //       inline: 'center'
    //     });
    //   } catch (e) {
    //     // Fallback to instant scroll
    //     targetMediaItem.scrollIntoView({ block: 'nearest', inline: 'center' });
    //   }
    // }, 150);

    if (DEBUG) console.log('[Gallery Update] DOM manipulation completed');
  }

  /**
   * Fallback: Try to update gallery based on variant options
   * Used when variant doesn't have featured_media
   */
  function updateGalleryByVariantOptions(productMedia, variant) {
    if (isVariantGallery()) return;
    // This is a fallback - try to find media that matches variant options
    // This is less reliable but better than nothing
    const DEBUG = false;
    if (DEBUG) console.log('[Gallery Update] Attempting to find media by variant options');

    // Get all media items
    const mediaItems = productMedia.querySelectorAll('.product__media-item[data-media-id]');

    // Try to find the first non-filtered media item
    for (let item of mediaItems) {
      if (!item.classList.contains('is-filtered')) {
        const mediaId = item.getAttribute('data-media-id');
        updateGalleryViaDOM(productMedia, mediaId, variant);
        break;
      }
    }
  }

  /**
   * Ensure form connection works properly
   * This fixes potential timing issues where ProductMedia initializes before form exists
   */
  function ensureFormConnection() {
    const productMediaElements = document.querySelectorAll('product-media.product__media');

    productMediaElements.forEach(productMedia => {
      const formId = productMedia.getAttribute('form-id');
      if (!formId) {
        console.warn('[Gallery Update] ProductMedia missing form-id attribute');
        return;
      }

      const form = document.getElementById(formId);
      if (!form) {
        console.warn('[Gallery Update] Form not found with ID:', formId);
        // Try to find form by other means
        const alternativeForm = document.querySelector(`form[id*="product-form"]`);
        if (alternativeForm) {
          alternativeForm.addEventListener('variant:changed', handleVariantChanged);
        }
        return;
      }

      // Check if listener is already attached (prevent duplicates)
      if (!form._galleryUpdateListenerAttached) {
        form.addEventListener('variant:changed', handleVariantChanged);
        form._galleryUpdateListenerAttached = true;
      }
    });
  }

  /**
   * Listen for option changes directly as backup
   * This catches cases where variant:changed might not fire
   */
  function setupOptionChangeListener() {
    const DEBUG = false;

    // Use event delegation to catch all option changes
    document.addEventListener('change', function (e) {
      const target = e.target;

      // Check if it's an option input/select (including block-swatch radios)
      if (target.matches('input[name^="option"], select[name^="option"], .block-swatch__radio, .color-swatch__radio, .variant-swatch__radio')) {
        if (DEBUG) console.log('[Gallery Update] Option change detected:', {
          name: target.name,
          value: target.value,
          type: target.type,
          checked: target.checked
        });

        // Only process if it's actually checked/selected
        if (target.type === 'radio' && !target.checked) {
          return;
        }

        // Wait a moment for variant selection to complete
        setTimeout(() => {
          updateGalleryFromForm(target);
        }, 150);

        // Also try after longer delay as backup
        setTimeout(() => {
          updateGalleryFromForm(target);
        }, 600);

        // Reorder ALL matching color images AFTER single-image updates
        setTimeout(() => {
          reorderGalleryBySwatchValue(target);
        }, 250);
        setTimeout(() => {
          reorderGalleryBySwatchValue(target);
        }, 800);
      }
    }, true); // Use capture phase
  }

  /**
   * Direct click handler for swatches and variant images
   * This ensures gallery updates even if events don't propagate correctly
   */
  function setupSwatchClickHandler() {
    const DEBUG = false;

    // Listen for clicks on swatch labels and variant swatches
    document.addEventListener('click', function (e) {
      const target = e.target;

      // Check if clicked on a swatch label, variant swatch image, or block swatch
      // Also check for clicks inside the swatch (like on links or text)
      const swatchItem = target.closest('.color-swatch__item, .variant-swatch__item, .block-swatch__item, .block-swatch');
      if (!swatchItem) return;

      // Prevent default if it's a link inside swatch
      // if (target.tagName === 'A' && target.closest('.block-swatch__item')) {
      //   e.preventDefault();
      // }

      // Find the associated radio input
      let radioInput = null;

      // Method 1: Check if swatchItem is a label with 'for' attribute
      if (swatchItem.tagName === 'LABEL') {
        const swatchId = swatchItem.getAttribute('for');
        if (swatchId) {
          radioInput = document.getElementById(swatchId);
        }
      }

      // Method 2: Find radio input in the same block-swatch container
      if (!radioInput) {
        const blockSwatch = swatchItem.closest('.block-swatch');
        if (blockSwatch) {
          radioInput = blockSwatch.querySelector('input[type="radio"].block-swatch__radio');
        }
      }

      // Method 3: Find as sibling
      if (!radioInput) {
        radioInput = swatchItem.previousElementSibling;
        if (!radioInput || radioInput.type !== 'radio') {
          radioInput = swatchItem.parentElement?.querySelector('input[type="radio"]');
        }
      }

      if (!radioInput || radioInput.type !== 'radio') {
        if (DEBUG) console.warn('[Gallery Update] Could not find radio input for swatch');
        return;
      }

      // Don't process if this radio is already checked
      if (radioInput.checked) {
        if (DEBUG) console.log('[Gallery Update] Swatch already selected, skipping');
        return;
      }

      if (DEBUG) console.log('[Gallery Update] Swatch clicked:', {
        name: radioInput.name,
        value: radioInput.value,
        form: radioInput.form?.id || radioInput.getAttribute('form')
      });

      // Check the radio programmatically to trigger change event
      radioInput.checked = true;

      // Trigger change event to ensure ProductVariants class processes it
      const changeEvent = new Event('change', { bubbles: true, cancelable: true });
      radioInput.dispatchEvent(changeEvent);

      // Wait for the variant selection to complete
      setTimeout(() => {
        updateGalleryFromForm(radioInput);
      }, 100);

      // Also try after a longer delay as backup
      setTimeout(() => {
        updateGalleryFromForm(radioInput);
      }, 500);

      // Reorder ALL matching color images AFTER single-image updates
      setTimeout(() => {
        reorderGalleryBySwatchValue(radioInput);
      }, 200);
      setTimeout(() => {
        reorderGalleryBySwatchValue(radioInput);
      }, 700);
    }, true); // Use capture phase to catch early
  }

  /**
   * Helper function to update gallery from form state
   */
  function updateGalleryFromForm(inputElement) {
    if (isVariantGallery()) return;
    const DEBUG = false;
    const form = inputElement.closest('form') ||
      (inputElement.form ? document.getElementById(inputElement.form) : null) ||
      document.querySelector(`form#${inputElement.getAttribute('form')}`) ||
      document.querySelector('form[id^="product-form"]');

    if (!form) {
      if (DEBUG) console.warn('[Gallery Update] Form not found');
      return;
    }

    const productMedia = document.querySelector('product-media.product__media');
    if (!productMedia) {
      if (DEBUG) console.warn('[Gallery Update] Product media element not found');
      return;
    }

    // Get the variant ID from the form
    const variantIdInput = form.querySelector('input[name="id"]:not([disabled])');
    let variantId = null;

    if (variantIdInput && variantIdInput.value) {
      variantId = parseInt(variantIdInput.value);
      if (DEBUG) console.log('[Gallery Update] Current variant ID from form:', variantId);

      // Only update if variant actually changed
      if (variantId === lastUpdatedVariantId) {
        if (DEBUG) console.log('[Gallery Update] Variant unchanged, skipping');
        return;
      }
    } else {
      // Variant ID not available yet, try to find variant by options
      if (DEBUG) console.log('[Gallery Update] Variant ID not available, finding by options');
      findVariantByOptions(form, productMedia, inputElement);
      return;
    }

    // Try to get variant info from product data
    if (productMedia.product) {
      Promise.resolve(productMedia.product).then(product => {
        const variant = product.variants.find(v => v.id === variantId);
        if (!variant) {
          if (DEBUG) console.warn('[Gallery Update] Variant not found in product data:', variantId);
          // Try finding by options as fallback
          findVariantByOptions(form, productMedia, inputElement);
          return;
        }

        if (DEBUG) console.log('[Gallery Update] Found variant:', {
          id: variant.id,
          title: variant.title,
          hasFeaturedMedia: !!variant.featured_media,
          featuredMediaId: variant.featured_media?.id
        });

        if (variant.featured_media && variant.featured_media.id) {
          // Try to find the section ID to construct full media ID
          const form = document.querySelector('form[id^="product-form"]');
          let fullMediaId = variant.featured_media.id;

          if (form) {
            const formId = form.id;
            // Extract section ID from form ID (format: product-form-{section.id}-{product.id})
            const formIdParts = formId.split('-');
            if (formIdParts.length >= 3) {
              // Reconstruct section ID (everything between "product-form" and product ID)
              const sectionIdParts = formIdParts.slice(2, -1);
              const sectionId = sectionIdParts.join('-');
              // Construct full media ID: section.id-media.id
              fullMediaId = `${sectionId}-${variant.featured_media.id}`;
              if (DEBUG) console.log('[Gallery Update] Constructed full media ID:', fullMediaId);
            }
          }

          // Try with full media ID first, then fallback to just media ID
          updateGalleryImage(productMedia, fullMediaId, variant);

          // Also try with just the media ID as fallback
          if (fullMediaId !== String(variant.featured_media.id)) {
            setTimeout(() => {
              updateGalleryImage(productMedia, variant.featured_media.id, variant);
            }, 200);
          }
        } else {
          if (DEBUG) console.warn('[Gallery Update] Variant has no featured media');
          // Try to find media by variant options
          updateGalleryByVariantOptions(productMedia, variant);
        }
      }).catch(err => {
        if (DEBUG) console.warn('[Gallery Update] Error getting variant from product:', err);
        // Fallback: try to find media by option value
        findVariantByOptions(form, productMedia, inputElement);
      });
    } else {
      // Product not loaded yet, try direct option-based approach
      if (DEBUG) console.log('[Gallery Update] Product not loaded, trying option-based update');
      findVariantByOptions(form, productMedia, inputElement);
    }
  }

  /**
   * Find variant by matching selected options
   */
  function findVariantByOptions(form, productMedia, inputElement) {
    const DEBUG = false;

    // Get all selected options
    const selectedOptions = [];
    const optionInputs = form.querySelectorAll('input[name^="option"]:checked, select[name^="option"]');
    optionInputs.forEach(input => {
      const optionNum = parseInt(input.name.replace('option', ''));
      selectedOptions[optionNum - 1] = input.value;
    });

    if (DEBUG) console.log('[Gallery Update] Selected options:', selectedOptions);

    if (productMedia.product) {
      Promise.resolve(productMedia.product).then(product => {
        // Find variant that matches all selected options
        const variant = product.variants.find(v => {
          return v.options.every((optionValue, index) => {
            return optionValue === selectedOptions[index];
          });
        });

        if (variant) {
          if (DEBUG) console.log('[Gallery Update] Found variant by options:', variant.id);
          if (variant.featured_media && variant.featured_media.id) {
            updateGalleryImage(productMedia, variant.featured_media.id, variant);
          } else {
            updateGalleryByOptionValue(productMedia, inputElement);
          }
        } else {
          if (DEBUG) console.warn('[Gallery Update] No variant found matching options');
          updateGalleryByOptionValue(productMedia, inputElement);
        }
      }).catch(err => {
        if (DEBUG) console.warn('[Gallery Update] Error in findVariantByOptions:', err);
        updateGalleryByOptionValue(productMedia, inputElement);
      });
    } else {
      updateGalleryByOptionValue(productMedia, inputElement);
    }
  }

  /**
   * Fallback: Update gallery based on option value
   * This tries to find media that might be associated with the selected option
   */
  function updateGalleryByOptionValue(productMedia, radioInput) {
    if (isVariantGallery()) return;
    const DEBUG = false;
    if (DEBUG) console.log('[Gallery Update] Attempting option-based gallery update');

    // First try Glide slides
    const glideSlides = productMedia.querySelectorAll('.glide__slide[data-media-id]');
    if (glideSlides.length > 0) {
      // Find the first visible/non-hidden slide
      for (let slide of glideSlides) {
        if (slide.style.display !== 'none' && !slide.classList.contains('is-filtered')) {
          const slideIndex = Array.from(glideSlides).indexOf(slide);
          if (DEBUG) console.log('[Gallery Update] Selecting Glide slide at index:', slideIndex);

          // Try Glide API
          const carousel = productMedia.querySelector('#mainProductCarousel, .carousel');
          if (carousel && carousel._glide) {
            try {
              carousel._glide.go(`=${slideIndex}`);
              return;
            } catch (e) {
              if (DEBUG) console.warn('[Gallery Update] Glide.go failed:', e);
            }
          }

          // Try Slick
          if (typeof $ !== 'undefined' && $('#mainProductCarousel').hasClass('slick-initialized')) {
            try {
              $('#mainProductCarousel').slick('slickGoTo', slideIndex, true);
              return;
            } catch (e) {
              if (DEBUG) console.warn('[Gallery Update] Slick failed:', e);
            }
          }

          // Direct manipulation - move to first position
          const glideSlidesContainer = slide.closest('.glide__slides');
          if (glideSlidesContainer) {
            // Remove slide from current position
            slide.remove();
            // Insert at beginning
            glideSlidesContainer.insertBefore(slide, glideSlidesContainer.firstChild);

            // Update active classes
            const allSlides = glideSlidesContainer.querySelectorAll('.glide__slide');
            allSlides.forEach((s, i) => {
              if (i === 0) {
                s.classList.add('is-active');
              } else {
                s.classList.remove('is-active');
              }
            });

            if (DEBUG) console.log('[Gallery Update] Moved slide to first position via option-based update');
          }

          return;
        }
      }
    }

    // Fallback to Flickity structure
    const mediaItems = productMedia.querySelectorAll('.product__media-item[data-media-id]');

    // Try to find media that's not filtered
    for (let item of mediaItems) {
      if (!item.classList.contains('is-filtered')) {
        const mediaId = item.getAttribute('data-media-id');
        if (DEBUG) console.log('[Gallery Update] Selecting first non-filtered media:', mediaId);

        // Update classes
        mediaItems.forEach(m => {
          m.classList.remove('is-selected', 'is-initial-selected');
        });
        item.classList.add('is-selected', 'is-initial-selected');

        // Try to select in carousel
        const flickityCarousel = productMedia.querySelector('flickity-carousel');
        if (flickityCarousel) {
          try {
            const selector = `[data-media-id="${mediaId}"]`;
            if (typeof flickityCarousel.select === 'function') {
              flickityCarousel.select(selector);
            }
          } catch (e) {
            if (DEBUG) console.warn('[Gallery Update] Carousel select failed:', e);
          }
        }

        // Scroll into view
        // setTimeout(() => {
        //   item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        // }, 100);

        break;
      }
    }
  }

  /**
   * Normalize swatch / color value for comparison
   */
  function normalizeSwatchValue(value) {
    if (!value) return '';
    return String(value)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  /**
   * Rough comparison between two normalized color strings
   * Handles minor spelling differences (e.g. "granaat" vs "granet")
   */
  function colorsRoughlyEqual(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;

    // Compare common prefix length
    const len = Math.min(a.length, b.length);
    let prefixLen = 0;
    for (let i = 0; i < len; i++) {
      if (a[i] === b[i]) {
        prefixLen++;
      } else {
        break;
      }
    }

    // Require at least 4 matching leading characters to avoid random matches
    return prefixLen >= 4;
  }

  /**
   * Reorder product media so that all images whose data-alt-image
   * matches the selected color are moved to the first positions.
   *
   * Expects data-alt-image like "color-Red" (case-insensitive).
   */
  /**
   * The redesigned templates show the gallery as a horizontal swipe list with position dots on mobile
   * (product-gallery.liquid). Reordering its images would put the dots out of step with the photo.
   */
  function isSwipeGallery(mediaList) {
    return !!mediaList && !!mediaList.closest('product-media') &&
      !!mediaList.closest('product-media').querySelector('.avj-gallery-progress') &&
      mediaList.scrollWidth > mediaList.clientWidth + 1;
  }

  function reorderMediaBySwatchColor(productMedia, swatchValue) {
    if (isVariantGallery()) return;
    const mediaList = productMedia.querySelector('.product__media-list');
    if (!mediaList || isSwipeGallery(mediaList)) return;

    const normalizedSwatch = normalizeSwatchValue(swatchValue);
    if (!normalizedSwatch) return;

    const items = Array.from(mediaList.querySelectorAll('.product__media-item'));
    if (!items.length) return;

    const matching = [];
    const nonMatching = [];

    items.forEach(item => {
      const altImage = item.getAttribute('data-alt-image') || '';
      const match = altImage.match(/color-([^\s#]+)/i) || altImage.match(/color\s*[-_:]\s*([^#]+)/i);
      if (!match || !match[1]) {
        nonMatching.push(item);
        return;
      }

      const altColor = normalizeSwatchValue(match[1]);
      if (altColor && colorsRoughlyEqual(altColor, normalizedSwatch)) {
        matching.push(item);
      } else {
        nonMatching.push(item);
      }
    });

    // If there are no matching images, do nothing
    if (!matching.length) return;

    // Re-append in new order while preserving relative order within each group
    const ordered = matching.concat(nonMatching);
    ordered.forEach(node => {
      if (node.parentElement === mediaList) {
        mediaList.appendChild(node);
      }
    });
  }

  /**
   * Extract color value from a media item's data-alt-image attribute.
   * Parses "color-Red" or "color-Granaat" etc. and returns the color part.
   * Returns null if no color found.
   */
  function getColorFromMediaItem(productMedia, mediaId) {
    if (!productMedia || !mediaId) return null;
    const mediaList = productMedia.querySelector('.product__media-list');
    if (!mediaList) return null;

    // Find the media item by data-media-id
    const items = mediaList.querySelectorAll('.product__media-item');
    for (const item of items) {
      const itemMediaId = item.getAttribute('data-media-id');
      if (itemMediaId && (itemMediaId == mediaId || itemMediaId.endsWith('-' + mediaId))) {
        const altImage = item.getAttribute('data-alt-image') || '';
        const match = altImage.match(/color-([^\s#]+)/i) || altImage.match(/color\s*[-_:]\s*([^#]+)/i);
        if (match && match[1]) {
          return match[1];
        }
      }
    }
    return null;
  }

  /**
   * Determine selected swatch color (if any) and reorder gallery images.
   * Translation-safe: tries to read color from variant's featured media
   * data-alt-image first, falls back to swatch value.
   */
  function reorderGalleryBySwatchValue(inputElement) {
    if (isVariantGallery()) return;
    const productMedia = document.querySelector('product-media.product__media');
    if (!productMedia) return;

    // Strategy 1 (translation-safe): Read color from variant's featured media data-alt-image
    // Both source and target colors come from data-alt-image, so they're always in the same language
    const form = inputElement.closest && inputElement.closest('form') ||
      (inputElement.getAttribute && inputElement.getAttribute('form') && document.getElementById(inputElement.getAttribute('form'))) ||
      document.querySelector('form[id^="product-form"]');

    if (form) {
      const variantIdInput = form.querySelector('input[name="id"]:not([disabled])');
      if (variantIdInput && variantIdInput.value && productMedia.product) {
        Promise.resolve(productMedia.product).then(product => {
          if (!product || !product.variants) return;
          const variant = product.variants.find(v => v.id === parseInt(variantIdInput.value));
          if (variant && variant.featured_media && variant.featured_media.id) {
            const colorFromMedia = getColorFromMediaItem(productMedia, variant.featured_media.id);
            if (colorFromMedia) {
              reorderMediaBySwatchColor(productMedia, colorFromMedia);
              return;
            }
          }
          // Fallback to swatch value
          reorderBySwatchValueFallback(inputElement, productMedia);
        }).catch(() => {
          reorderBySwatchValueFallback(inputElement, productMedia);
        });
        return;
      }
    }

    // Fallback: use swatch value directly
    reorderBySwatchValueFallback(inputElement, productMedia);
  }

  /**
   * Fallback: reorder using the swatch input value directly
   */
  function reorderBySwatchValueFallback(inputElement, productMedia) {
    let swatchValue = null;

    if (inputElement.matches && inputElement.matches('.block-swatch__radio, .color-swatch__radio, .variant-swatch__radio')) {
      swatchValue = inputElement.value;
    } else {
      const form = inputElement.closest && inputElement.closest('form');
      if (form) {
        const checkedSwatch = form.querySelector('.block-swatch__radio:checked, .color-swatch__radio:checked, .variant-swatch__radio:checked');
        if (checkedSwatch) {
          swatchValue = checkedSwatch.value;
        }
      }
    }

    if (!swatchValue) return;
    reorderMediaBySwatchColor(productMedia, swatchValue);
  }


  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureFormConnection();
      setupOptionChangeListener();
      setupSwatchClickHandler();
    });
  } else {
    ensureFormConnection();
    setupOptionChangeListener();
    setupSwatchClickHandler();
  }

  // Also run after a short delay to catch late-loading elements
  setTimeout(() => {
    ensureFormConnection();
  }, 1000);

  // Listen for variant:changed event (primary method)
  document.addEventListener('variant:changed', handleVariantChanged);

  // Also listen on document for broader compatibility
  document.addEventListener('variant:changed', handleVariantChanged, true);

})();

// GALLERY IMAGE UPDATE ON VARIANT CHANGE ends

// smooth scroll to career section on button starts here

document.querySelectorAll('.template-page-werken-bij .image-with-text-full .image-with-text__content-wrapper .image-with-text__content-list a.button').forEach(btn => {
  btn.addEventListener('click', function(e) {
    const targetId = this.getAttribute('href');

    if (targetId && targetId.startsWith('#')) {
      e.preventDefault();

      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });
});

// smooth scroll to career section on button ends here


// custom search drawer open starts here
  document.addEventListener("DOMContentLoaded", function () {
    let searchOpening = false;
    document.addEventListener("click", function (e) {
      const stickySearch = e.target.closest(".sticky-mobile-search");
      if (!stickySearch || searchOpening) return;
      searchOpening = true;
      const headerIcon = document.querySelector(".header__icon-wrapper.search");
      if (headerIcon) {
        headerIcon.click();
        const interval = setInterval(() => {
          const input = document.querySelector(".predictive-search__input");
          if (input) {
            input.focus();
            input.click();
            clearInterval(interval);
            setTimeout(() => {
              searchOpening = false;
            }, 600);
          }
        }, 100);
        setTimeout(() => {
          clearInterval(interval);
          searchOpening = false;
        }, 2000);
      }
    });
  });

// custom search drawer open ends here


// open returnless menu in new tab starts here

document.addEventListener("DOMContentLoaded", function() {
  // Selects all links that contain 'returnless.com' in their URL
  var returnLinks = document.querySelectorAll('a[href*="returnless.com"]');
  
  returnLinks.forEach(function(link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer'); // Best practice for security and performance
  });
});

// open returnless menu in new tab ends here

